__turbopack_context__.v({
  "className": "instrument_sans_fadc9b9d-module__Y_bITG__className",
  "variable": "instrument_sans_fadc9b9d-module__Y_bITG__variable",
});
